import React, { forwardRef } from 'react';
import { Field as FormField } from 'react-final-form';
import { validation } from '@vmos2/utils';

import { Input } from './Input';

type Props = {
  name: string,
  type: string,
  component: React.Node,
  values: string,
  validate: Function,
  rest: mixed[],
};

// $FlowFixMe
export const Field = forwardRef(({ name, component = Input, type = 'text', values, validate, ...rest }: Props, ref) => (
  <FormField
    component={component}
    name={name}
    ref={ref}
    showContentButton={type === 'password'}
    type={type}
    validate={validate && validation.combineValidationRules(validate)}
    {...rest}
  />
));
